<template>
  <div class="more-tools">
    <div class="header">
      More tools by 🐼
      <a class="panda" href="https://panda.network" target="_blank"
        >Panda Network</a
      >
      <div class="tools">
        <a href="https://collectui.com" target="_blank" class="tool cursor">
          <img loading="lazy" src="@/assets/sites/collectui.png" alt="" />
          <span class="title">Collect UI</span>
          <span class="descr">Categorized design inspiration.</span>
        </a>
        <!-- /.tool -->
        <a href="https://flatuicolors.com" target="_blank" class="tool cursor">
          <img loading="lazy" src="@/assets/sites/flatui.png" alt="" />
          <span class="title">Flat UI Colors 2</span>
          <span class="descr">Set of colors for your next project.</span>
        </a>
        <!-- /.tool -->
        <a href="https://usepanda.com" target="_blank" class="tool cursor">
          <img loading="lazy" src="@/assets/sites/panda.png" alt="" />
          <span class="title">Panda</span>
          <span class="descr">Daily News for Tech People.</span>
        </a>
        <!-- /.tool -->
        <a href="https://thestocks.im" target="_blank" class="tool cursor">
          <img loading="lazy" src="@/assets/sites/thestocks.png" alt="" />
          <span class="title">TheStocks</span>
          <span class="descr">Collection of free design resources.</span>
        </a>
        <!-- /.tool -->

        <a href="https://pfolios.net" target="_blank" class="tool cursor">
          <img loading="lazy" src="@/assets/sites/pfolios.png" alt="" />
          <span class="title">Pfolios</span>
          <span class="descr">Inspiring Portfolios.</span>
        </a>
        <!-- /.tool -->
        <a href="https://thenews.im" target="_blank" class="tool cursor">
          <img loading="lazy" src="@/assets/sites/thenews.png" alt="" />
          <span class="title">TheNews Mobile</span>
          <span class="descr">Tech News on Mobile.</span>
        </a>
        <!-- /.tool -->
        <a href="https://coronapanel.com" target="_blank" class="tool cursor">
          <img loading="lazy" src="@/assets/sites/coronapanel.png" alt="" />
          <span class="title">Corona Panel</span>
          <span class="descr">All information about Covid-19.</span>
        </a>
        <!-- /.tool -->
        <a href="https://learnemp.com" target="_blank" class="tool cursor">
          <img loading="lazy" src="@/assets/sites/learnemp.png" alt="" />
          <span class="title">LearnEMP</span>
          <span class="descr">Learn electronic music production.</span>
        </a>
        <!-- /.tool -->
        <a
          href="https://materialuicolors.co"
          target="_blank"
          class="tool cursor"
        >
          <img loading="lazy" src="@/assets/sites/materialui.png" alt="" />
          <span class="title">Material UI Colors</span>
          <span class="descr">Color palettes for Google’s MDS.</span>
        </a>
        <!-- /.tool -->
      </div>
      <!-- /.tools -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Welcome",
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/inc/common.scss";

.more-tools {
  width: 100%;
  max-width: 1024px;
  margin-top: 100px;
  font-weight: 500;
  padding-bottom: 50px;
  .panda {
    font-weight: bold;
    text-decoration: underline;
    color: #224185;
  }
  .header {
    text-align: center;
  }
  .tools {
    width: 100%;
    float: left;
    display: flex;
    margin-top: 32px;
    justify-content: space-between;
    transform: scale(1);
    flex-wrap: wrap;
    .tool {
      width: 320px;
      padding: 8px;
      height: 300px;
      margin-bottom: 32px;
      color: #224185;
      background: #ffffff;
      border: 1px solid #f0e0de;
      box-sizing: border-box;
      border-radius: 5px;
      transition: all 0.2s;
      &:hover {
        transform: scale(1.1);
      }
      &:active {
        transform: scale(0.9);
      }
      img {
        width: 304px;
      }
      span {
        display: inline-block;
        width: 100%;
        text-indent: 16px;
      }
      .title {
        font-size: 22px;
        margin-top: 20px;
        margin-bottom: 8px;
        letter-spacing: -1%;
        font-weight: bold;
      }
      .descr {
        font-size: 15px;
        letter-spacing: -1%;
        opacity: 0.6;
      }
    }
  }
}

@media (max-width: 1279px) {
  .more-tools {
    max-width: 100%;
    width: 100%;
    .tools {
      flex: 1 0 100%;
      justify-content: center;
      align-items: center;
    }
    .tool {
      margin: 0 32px;
    }
  }
}

@media (min-width: $mobile-max) and (max-width: 1023px) {
  .more-tools {
    max-width: 100%;
    width: 100%;
    .header {
      text-align: center;
    }
    .tools {
      flex: 1 0 100%;
      justify-content: center;
      align-items: center;
    }
    .tools .tool {
      margin: 0 32px;
      width: 40%;
      height: auto;
      margin-bottom: 40px;
      img {
        width: 100%;
      }
      span {
        text-indent: 2px;
      }
      .title {
        margin-top: 13px;
      }
    }
  }
}

.cursor {
  cursor: url("data:image/svg+xml,%3Csvg%20width%3D%2292%22%20height%3D%2298%22%20viewBox%3D%220%200%2092%2098%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M19.1563%2071.1847C17.5233%2069.1204%2015.5395%2064.8999%2012.009%2059.7767C10.008%2056.8787%205.04575%2051.4219%203.568%2048.6504C2.28575%2046.2009%202.42375%2045.1027%202.7285%2043.0729C3.269%2039.4619%206.972%2036.6502%2010.9223%2037.0297C13.9065%2037.3114%2016.4365%2039.2837%2018.7135%2041.1467C20.0878%2042.2679%2021.7783%2044.4472%2022.796%2045.6777C23.7333%2046.8047%2023.9633%2047.2704%2024.9638%2048.6044C26.2863%2050.3697%2026.7003%2051.2437%2026.1943%2049.3002C25.786%2046.4482%2025.119%2041.5779%2024.153%2037.2712C23.417%2034.0052%2023.2388%2033.4934%2022.5373%2030.9864C21.7955%2028.3184%2021.416%2026.4497%2020.7203%2023.6207C20.2373%2021.6197%2019.369%2017.5314%2019.1333%2015.2314C18.8055%2012.0862%2018.633%206.95717%2020.6513%204.59967C22.2325%202.75392%2025.8608%202.19617%2028.109%203.33467C31.053%204.82392%2032.7263%209.10192%2033.491%2010.8097C34.8653%2013.8802%2035.7163%2017.4279%2036.458%2022.0854C37.401%2028.0137%2039.1375%2036.2419%2039.195%2037.9727C39.333%2035.8509%2038.804%2031.3832%2039.172%2029.3477C39.5055%2027.5019%2041.058%2025.3572%2043.0015%2024.7764C44.646%2024.2877%2046.5723%2024.1094%2048.2685%2024.4602C50.0683%2024.8282%2051.9657%2026.1162%2052.673%2027.3294C54.7545%2030.9174%2054.7948%2038.2487%2054.881%2037.8577C55.3755%2035.6957%2055.2892%2030.7909%2056.514%2028.7497C57.319%2027.4042%2059.3717%2026.1909%2060.4642%2025.9954C62.1548%2025.6964%2064.2305%2025.6044%2066.0072%2025.9494C67.439%2026.2312%2069.3767%2027.9332%2069.9%2028.7497C71.1535%2030.7277%2071.8665%2036.3224%2072.0792%2038.2832C72.1655%2039.0939%2072.5047%2036.0292%2073.764%2034.0512C76.0985%2030.3769%2084.3612%2029.6639%2084.6775%2037.7254C84.8213%2041.4859%2084.7925%2041.3134%2084.7925%2043.8434C84.7925%2046.8162%2084.7235%2048.6044%2084.5625%2050.7549C84.3842%2053.0549%2083.8898%2058.2529%2083.171%2060.7714C82.6765%2062.5022%2081.0378%2066.3949%2079.422%2068.7294C79.422%2068.7294%2073.2465%2075.9169%2072.5738%2079.1542C71.8952%2082.3857%2072.1195%2082.4087%2071.9873%2084.7029C71.855%2086.9914%2072.683%2090.0044%2072.683%2090.0044C72.683%2090.0044%2068.0715%2090.6024%2065.5875%2090.2057C63.3392%2089.8434%2060.5562%2085.3699%2059.8375%2084.0014C58.8485%2082.1154%2056.7382%2082.4777%2055.916%2083.8692C54.6222%2086.0714%2051.8392%2090.0217%2049.8727%2090.2689C46.0317%2090.7519%2038.0623%2090.4472%2031.8235%2090.3839C31.8235%2090.3839%2032.8873%2084.5707%2030.5183%2082.5754C28.7645%2081.0862%2025.7458%2078.0674%2023.9403%2076.4804L19.1563%2071.1847Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M19.1563%2071.1847C17.5233%2069.1204%2015.5395%2064.8999%2012.009%2059.7767C10.008%2056.8787%205.04575%2051.4219%203.568%2048.6504C2.28575%2046.2009%202.42375%2045.1027%202.7285%2043.0729C3.269%2039.4619%206.972%2036.6502%2010.9223%2037.0297C13.9065%2037.3114%2016.4365%2039.2837%2018.7135%2041.1467C20.0878%2042.2679%2021.7783%2044.4472%2022.796%2045.6777C23.7333%2046.8047%2023.9633%2047.2704%2024.9638%2048.6044C26.2863%2050.3697%2026.7003%2051.2437%2026.1943%2049.3002C25.786%2046.4482%2025.119%2041.5779%2024.153%2037.2712C23.417%2034.0052%2023.2388%2033.4934%2022.5373%2030.9864C21.7955%2028.3184%2021.416%2026.4497%2020.7203%2023.6207C20.2373%2021.6197%2019.369%2017.5314%2019.1333%2015.2314C18.8055%2012.0862%2018.633%206.95717%2020.6513%204.59967C22.2325%202.75392%2025.8608%202.19617%2028.109%203.33467C31.053%204.82392%2032.7263%209.10192%2033.491%2010.8097C34.8653%2013.8802%2035.7163%2017.4279%2036.458%2022.0854C37.401%2028.0137%2039.1375%2036.2419%2039.195%2037.9727C39.333%2035.8509%2038.804%2031.3832%2039.172%2029.3477C39.5055%2027.5019%2041.058%2025.3572%2043.0015%2024.7764C44.646%2024.2877%2046.5723%2024.1094%2048.2685%2024.4602C50.0683%2024.8282%2051.9657%2026.1162%2052.673%2027.3294C54.7545%2030.9174%2054.7948%2038.2487%2054.881%2037.8577C55.3755%2035.6957%2055.2892%2030.7909%2056.514%2028.7497C57.319%2027.4042%2059.3718%2026.1909%2060.4643%2025.9954C62.1548%2025.6964%2064.2305%2025.6044%2066.0072%2025.9494C67.439%2026.2312%2069.3767%2027.9332%2069.9%2028.7497C71.1535%2030.7277%2071.8665%2036.3224%2072.0792%2038.2832C72.1655%2039.0939%2072.5047%2036.0292%2073.764%2034.0512C76.0985%2030.3769%2084.3612%2029.6639%2084.6775%2037.7254C84.8212%2041.4859%2084.7925%2041.3134%2084.7925%2043.8434C84.7925%2046.8162%2084.7235%2048.6044%2084.5625%2050.7549C84.3843%2053.0549%2083.8898%2058.2529%2083.171%2060.7714C82.6765%2062.5022%2081.0378%2066.3949%2079.422%2068.7294C79.422%2068.7294%2073.2465%2075.9169%2072.5738%2079.1542C71.8953%2082.3857%2072.1195%2082.4087%2071.9872%2084.7029C71.855%2086.9914%2072.683%2090.0044%2072.683%2090.0044C72.683%2090.0044%2068.0715%2090.6024%2065.5875%2090.2057C63.3392%2089.8434%2060.5562%2085.3699%2059.8375%2084.0014C58.8485%2082.1154%2056.7382%2082.4777%2055.916%2083.8692C54.6222%2086.0714%2051.8393%2090.0217%2049.8728%2090.2689C46.0318%2090.7519%2038.0623%2090.4472%2031.8235%2090.3839C31.8235%2090.3839%2032.8873%2084.5707%2030.5183%2082.5754C28.7645%2081.0862%2025.7458%2078.0674%2023.9403%2076.4804L19.1563%2071.1847Z%22%20stroke%3D%22black%22%20stroke-width%3D%224.3125%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M66.5068%2073.223V53.3337%22%20stroke%3D%22black%22%20stroke-width%3D%224.3125%22%20stroke-linecap%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M54.9174%2073.2906L54.8254%2053.3208%22%20stroke%3D%22black%22%20stroke-width%3D%224.3125%22%20stroke-linecap%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M43.4395%2053.5022L43.5602%2073.2017%22%20stroke%3D%22black%22%20stroke-width%3D%224.3125%22%20stroke-linecap%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E%0A")
      32 32,
    pointer;
}
</style>
